import React from "react";
import {
  Box,
  Container,
  Heading,
  VStack,
  HStack,
  Text,
  Button,
  Image,
  Divider,
} from "@chakra-ui/react";
import { useShopping } from "../context/ShoppingContext";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { cart, removeFromCart, updateCartQuantity, getCartTotal } =
    useShopping();
  const navigate = useNavigate();

  return (
    <Container maxW="900px" py={8}>
      <Heading mb={6}>Your Cart</Heading>
      {cart.length === 0 ? (
        <Text>Your cart is empty.</Text>
      ) : (
        <VStack align="stretch" spacing={6}>
          {cart.map((item) => (
            <Box key={item.id} p={4} borderWidth={1} borderRadius="md">
              <HStack spacing={4}>
                <Image
                  src={item.image}
                  alt={item.name}
                  boxSize="80px"
                  borderRadius="md"
                />
                <VStack align="start" spacing={1} flex={1}>
                  <Text fontWeight="bold">{item.name}</Text>
                  <Text color="gray.500">{item.series}</Text>
                  <Text color="blue.600" fontWeight="bold">
                    ₹{Number(item.price ?? item.mrp ?? 0).toLocaleString("en-IN")}
                  </Text>
                  <HStack>
                    <Button
                      size="sm"
                      onClick={() =>
                        updateCartQuantity(item.id, item.quantity - 1)
                      }
                    >
                      -
                    </Button>
                    <Text>{item.quantity}</Text>
                    <Button
                      size="sm"
                      onClick={() =>
                        updateCartQuantity(item.id, item.quantity + 1)
                      }
                    >
                      +
                    </Button>
                  </HStack>
                </VStack>
                <Button
                  colorScheme="red"
                  size="sm"
                  onClick={() => removeFromCart(item.id)}
                >
                  Remove
                </Button>
              </HStack>
            </Box>
          ))}
          <Divider />
          <HStack justify="space-between">
            <Text fontWeight="bold" fontSize="lg">
              Total:
            </Text>
            <Text fontWeight="bold" fontSize="lg" color="teal.600">
              ₹{getCartTotal().toLocaleString()}
            </Text>
          </HStack>
          <Button
            colorScheme="orange"
            size="lg"
            onClick={() => navigate("/checkout")}
          >
            Proceed to Checkout
          </Button>
        </VStack>
      )}
    </Container>
  );
};

export default Cart;
